// Created by hejikun on 2017/10/25 0025.
const state = {
  train_hasMore: false,
  train_order_list: [],
  plat_train_order_list: [],
  train_form_data: {
    user_id: '',
    // 预约类型 1 门诊预约 2 床位预约 3 检查预约 4 体检预约
    appointment_type: 0,
    // 乘车类型 1 包车 2 拼车 3 专车
    transit_type: 0,
    // 体检人数
    service_num: 0,
    // 体检类型
    examination_type: 0,
    // 检查项目
    check_item: {
      name: '',
      id: '',
      price: '',
      fee_mode: ''
    },
    // 就诊人信息
    patient_info: {
      patient_id: '',
      patient_name: ''
    },
    // 预约医院
    appointment_hospital: {
      hos_id: '',
      hos_name: '',
      hos_type: 0 // 医院类型（1：公立，2：民营，3：诊所）
    },
    // 预约科室
    appointment_department: {
      dep_id: '', // 门诊预约时存入
      dep_name: '',
      service_id: '', // 床位预约时存入
      service_code: '' // 服务类型
    },
    // 预约医生
    appointment_doctor: {
      doc_id: '',
      doc_name: '',
      flag: 0 // 如果选择医生，则自动生成预约时间 0: 未选择医生 1: 已选择医生
    },
    // 就诊时间
    appointment_time: {
      show: '', // 前台显示的时间格式
      value: 0, // 对应的时间戳
      type: 0 // 预约时间类型 1: 上午 2: 下午
    },
    // 乘客信息
    passengers: {
      adult: 0,
      baby: 0,
      child: 0,
      all: 0
    },
    // 乘车时间
    transit_time: {
      show: '', // 前台显示的时间格式
      value: 0, // 对应的时间戳
      startTime: '',
      endTime: ''
    },
    // 乘车信息
    transit_from_detail: {
      from: '', // 起点地
      from_id: 0, // 起始地ID
      sp_bus: 0,
      sp_pinche: 0,
      sp_zhuanche: 0
    },
    cl_detail: {
      // 拼车、专车信息
      name: '',
      clid: '',
      clpid: '',
      cltid: '',
      price: ''
    },
    traffic_schid: '',
    traffic_date: '',
    // 陪护人信息
    caregivers: [
      /* { idcard: '', phone: '', name: '', is_patient: 1, age_type: 1 } */
    ],
    // 地理定位信息
    geo_info: {
      latLng: '',
      name: '' // 位置名称
    },
    extra_fee: {
      datePrice: '', // 日期加价
      kmPrice: '', // 里程加价
      timePrice: '' // 超时段加价
    },
    service_fee: 0,
    service_fee2: 0,
    train_order: {
      order_no: '',
      price: ''
    }
  },
  train_service: {}, // 医院服务
  // 预约时间
  train_time_schedules: {
    status: 0,
    data: {}
  },
  train_order_detail: {}, // 订单详情
  train_area: {}, // 选中的出发地
  train_traffic_detail: {} // 交运详情
}

const actions = {
  loadTrainList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'train_order_list':
        url = `/ztc/user/getOrderList?user_id=${args.user_id}&page=${args.page}&page_size=${args.page_size}`
        break
      case 'plat_train_order_list':
        url = `/ztc/ltorder/getOrderList?user_id=${args.user_id}&page=${args.page}&page_size=${args.page_size}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res.data.code === 1
          ? (() => {
              commit({
                type: 'set_train_order_list',
                dataType: args.type,
                data: res.data.data,
                page: args.page
              })
            })()
          : commit({
              type: 'set_train_order_list',
              dataType: args.type,
              data: [],
              page: args.page
            })
        return Promise.resolve()
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const getters = {
  train_calc_post_data(state) {
    let data = {}
    const origin = state.train_form_data
    const service = state.train_service
    /*
     * 预约信息
     * */
    if (service.id) {
      data.service_hospital_id = service.id // 服务-医院关联ID
    }
    if (origin.user_id) {
      data.user_id = origin.user_id // 用户ID
    }
    if (origin.appointment_time.value) {
      data.service_date = origin.appointment_time.value // 预约日期，格式 2018-01-01
    }
    if (origin.service_num) {
      data.service_num = origin.service_num // 预约日期，格式 2018-01-01
    }
    // 门诊预约、住院预约
    if (origin.patient_info.patient_id) {
      data.patient_id = origin.patient_info.patient_id // 就诊人ID 选择就诊人时必须
    }
    // 门诊预约
    if (origin.appointment_time.type) {
      data.service_time_type = origin.appointment_time.type // 预约时间类型（1：上午、2：下午） 门诊预约时必须
    }
    if (origin.appointment_type) {
      data.appointment_type = origin.appointment_type // 科室编码 门诊预约时必须
    }
    if (origin.appointment_department.dep_id) {
      data.depart_code = origin.appointment_department.dep_id // 科室编码 门诊预约时必须
    }
    if (origin.appointment_department.dep_name) {
      data.depart_name = origin.appointment_department.dep_name // 科室名称 门诊预约时必须
    }
    if (origin.appointment_doctor.doc_id) {
      data.doctor_code = origin.appointment_doctor.doc_id // 医生编码 门诊预约时如选择了医生时必须
    }
    if (origin.appointment_doctor.doc_name) {
      data.doctor_name = origin.appointment_doctor.doc_name // 医生名 门诊预约时如选择了医生时必须
    }
    // 住院预约
    if (origin.appointment_department.service_id) {
      data.hospital_depart_id = origin.appointment_department.service_id // 住院科室ID 床位预约时必须
    }
    // 检查预约、体检预约
    if (origin.check_item.id) {
      data.hospital_service_id = origin.check_item.id // 医院检查项目/体检项目ID
    }
    /*
     * 交通信息
     * */
    if (origin.transit_from_detail.from_id) {
      data.area_id = origin.transit_from_detail.from_id // 选择二级地区ID
    }
    if (origin.transit_type) {
      data.traffic_type = origin.transit_type // 交通类型 1:班车、2：拼车、3：专车
    }
    if (origin.traffic_date) {
      data.traffic_date = origin.traffic_date // 出发日期 2018-01-01
    }
    if (origin.passengers.adult) {
      data.traffic_adult_count = origin.passengers.adult // 成人人数
    }
    if (origin.passengers.baby) {
      data.traffic_child_count = origin.passengers.baby // 儿童人数(班车时免票儿童数)
    }
    if (origin.caregivers) {
      data.traffic_passengers = origin.caregivers // 乘车人信息
    }
    // 班车信息
    if (origin.traffic_schid) {
      data.traffic_schid = origin.traffic_schid // 班次ID(班车的是场合时必须)
    }
    // 拼车、专车
    if (origin.geo_info.latLng) {
      data.traffic_start_location = origin.geo_info.latLng // 出发地址坐标（专车、拼车时必须） lat,lng
    }
    if (origin.geo_info.name) {
      data.traffic_start_address = origin.geo_info.name // 出发地址（专车、拼车时必须）
    }
    data.isp2p = origin.geo_info.isp2p // 出发地址（专车、拼车时必须）
    // if (origin.transit_time.value) {
    //   data.traffic_time = origin.transit_time.value // 出发时间（专车、拼车时必须） 08:10
    // }
    // 出发时间（专车、拼车时必须） 08:10:00
    if (origin.transit_time.startTime) {
      data.traffic_time = origin.transit_time.startTime
    }
    // 结束时间（专车、拼车时必须） 08:10:00
    if (origin.transit_time.endTime) {
      data.traffic_time_end = origin.transit_time.endTime
    }
    if (origin.passengers.adult) {
      data.traffic_adult_count = origin.passengers.adult // 成人人数
    }
    if (origin.passengers.all) {
      data.traffic_all_count = origin.passengers.all // 所有人数
    }
    if (origin.cl_detail.clid) {
      data.clid = origin.cl_detail.clid // clid
    }
    if (origin.cl_detail.clpid) {
      data.clpid = origin.cl_detail.clpid // clpid
    }
    if (origin.cl_detail.cltid) {
      data.cltid = origin.cl_detail.cltid // clpid
    }
    return data
  }
}

const mutations = {
  set_train_order_list(state, args) {
    let data = args
    data.data.length < 10 ? (state.train_hasMore = false) : (state.train_hasMore = true)
    if (data.page === 1) {
      if (data.data.length==0) {
        state[data.dataType] = []
      } else {
        state[data.dataType] = data.data
      }
    } else {
      if (args.data.length !== 0) {
        args.data.forEach((item) => {
          state[args.dataType].push(item)
        })
      }
    }
  },
  set_train_form_data(state, args) {
    if (args.type === 'caregivers') {
      switch (args.method) {
        case 'first':
          // 添加就诊人为乘车人
          state.train_form_data[args.type][0] = args.data
          break
        case 'push':
          // 添加乘车人信息
          if (args.type === 'caregivers') {
            let flag = 0
            state.train_form_data[args.type].forEach((person) => {
              if (args.data.idcard === person.idcard) {
                flag = 1
              }
            })
            if (!flag) {
              state.train_form_data[args.type].push(args.data)
            } else {
              args.vm.$toast('不能重复添加相同的身份证信息')
            }
          }
          break
        case 'remove':
          // 移除指定乘车人信息
          if (args.type === 'caregivers') {
            state.train_form_data[args.type] = state.train_form_data[args.type].filter((person) => {
              return args.data.idcard !== person.idcard
            })
          }
          break
        case 'removeAll':
          // 删除所有乘车人信息
          state.train_form_data[args.type] = []
          break
        default:
          break
      }
    } else {
      state.train_form_data[args.type] = args.data
    }
  },
  set_train_service(state, args) {
    state.train_service = args
  },
  set_train_time_schedules(state, args) {
    state.train_time_schedules = args
  },
  set_train_area(state, args) {
    state.train_area = args
  },
  set_train_traffic_detail(state, args) {
    state.train_traffic_detail = args
  },
  set_train_order_detail(state, args) {
    state.train_order_detail = args
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
